import { render, staticRenderFns } from "./VAlertList.vue?vue&type=template&id=606d2e77&scoped=true&"
import script from "./VAlertList.vue?vue&type=script&lang=js&"
export * from "./VAlertList.vue?vue&type=script&lang=js&"
import style0 from "./VAlertList.vue?vue&type=style&index=0&id=606d2e77&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606d2e77",
  null
  
)

export default component.exports